import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { showDeleteAlert } from "@components/molecules/alert";
import { useNotifyPromise } from "@hooks";
import { useCancelAppointment } from "@api/appointment";
import type { ID } from "@constants";
import { useUserStore } from "@/stores/userStore";
import { useNoShowAppointmentFunc } from "@components/organisms/appointmentCard/components/appointmentHelper/noShowAppointment";

export const useCancelAppointmentFunc = (id: ID) => {
  const { t } = useTranslation("form");
  const role = useUserStore((state) => state.role);

  const navigate = useNavigate();

  const notifyMutate = useNotifyPromise();
  const { mutateAsync } = useCancelAppointment();

  const noShow = useNoShowAppointmentFunc(id, true);

  if (role === "staff") return noShow;

  return (back?: boolean) =>
    showDeleteAlert({
      title: t("cancel_appointment"),
      content: t("cancel_appointment_text"),
      onApprove: async () => {
        await notifyMutate(
          mutateAsync(
            { appointmentId: id },
            back ? { onSuccess: () => navigate(-1) } : undefined,
          ),
        );
      },
      approveTitle: t("cancel_appointment"),
    });
};
